import React from "react";

export default props => (
  <div className="cb-c-page-banner-stack">{props.children}</div>
);
